import { render, staticRenderFns } from "./billing-data.vue?vue&type=template&id=9fdcc508&lang=pug"
import script from "./billing-data.vue?vue&type=script&lang=ts"
export * from "./billing-data.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports